import { useQuery } from '@tanstack/react-query'
import { api } from './api.js'

/** Query keys for the Account page and the 2FA banner, so a mutation can invalidate exactly one thing. */
export const accountKeys = {
  account: () => ['account'] as const,
  sessions: () => ['sessions'] as const,
  settings: () => ['settings'] as const,
}

export const useAccount = () => useQuery({ queryKey: accountKeys.account(), queryFn: () => api.getAccount() })

export const useSessions = () => useQuery({ queryKey: accountKeys.sessions(), queryFn: () => api.listSessions() })

/** The redacted instance settings; cached a minute because the banner reads it on every shell mount. */
export const useInstanceSettings = () =>
  useQuery({ queryKey: accountKeys.settings(), queryFn: () => api.getSettings(), staleTime: 60_000 })
